import React, { useState, useEffect } from "react";
import SubHead from "../SubHead";
import { Link, useNavigate, useParams } from "react-router-dom";

import { Get } from "../../../lib/Board";
import moment from "moment";

import { Viewer } from "@toast-ui/react-editor";
import "@toast-ui/editor/dist/toastui-editor-viewer.css";

const Info = props => {
    const params = useParams();
    const navigate = useNavigate();

    const [board, setBoard] = useState(params.board);
    const [data, setData] = useState();

    useEffect(() => {
        Get(params.id, resultInfo);
    }, [params.id]);

    /**
     * 리스트
     */
    const resultInfo = response => {
        setData(response);
    };

    if (!data) {
        return <></>;
    }

    return (
        <>
            <SubHead title="공시/홍보" eng="NOTICE"></SubHead>
            <main className="sub-contents">
                <div className="inner">
                    <div className="sub_tab_wrap">
                        <ul className="sub_tab">
                            <li className={board === "promotion" ? "on" : ""}>
                                <Link to={"/promotion/board/list"}>
                                    <a href="#">공시</a>
                                </Link>
                            </li>
                            <li className={board === "gallery" ? "on" : ""}>
                                <Link to={"/promotion/board/gallery"}>
                                    <a href="#">홍보</a>
                                </Link>
                            </li>
                        </ul>
                    </div>

                    <div className="board-detail-top">
                        <h2>{data.title}</h2>
                        <dl className="info">
                            <dt>날짜</dt>
                            <dd>{moment(data.createdAt).format("YYYY. MM. DD")}</dd>
                            <dt>작성자</dt>
                            <dd>{data.name}</dd>
                            <dt>조회</dt>
                            <dd>{data.show}회</dd>
                            {/* <dt>댓글</dt>
                            <dd>0건</dd> */}
                        </dl>
                    </div>
                    {data.uploadFiles && data.uploadFiles.length > 0 && (
                        <div className="board-detail-attachment">
                            <ul>
                                {data.uploadFiles.map(x => (
                                    <li>
                                        <a href={x.url} className="sbj">
                                            {x.originalname} ({x.size})
                                        </a>
                                        <p className="infos">Date : {moment(x.createdAt).format("YYYY-MM-DD HH:mm:ss")}</p>
                                    </li>
                                ))}

                                {/* <li>
                                    <a href="#" className="sbj">
                                        kt MOS북부 이음 5G 무선망시설공사 감리용역_과업내역서.docx (40.0K)
                                    </a>
                                    <p className="infos">8회 다운로드 Date : 2022-09-19 11:04:43</p>
                                </li> */}
                            </ul>
                        </div>
                    )}
                    <div className="board-detail-contents">
                        {/* <p>
                            1. 입찰개요
                            <br />
                            <br />
                            ㅇ 사업명: NIA 5G 융합서비스 공공부문 선도적용(공공의료_분당서울대학교병원)
                            <br />
                            ㅇ 공사현장
                            <br />
                            <br />
                            분당서울대학교병원 : 경기도 성남시 분당구 구미로173번길 82
                            <br />
                            - 헬스케어혁신파크센터 포함 (경기도 성남시 분당구 돌마로 172)
                            <br />
                            ㅇ 공사기간: 착공일~2022.12.31
                            <br />
                            <br />
                            2. 입찰방법
                            <br />
                            <br />
                            ㅇ 접수방법: 방문 또는 우편접수
                            <br />
                            ㅇ 접수처: 서울특별시 강남구 광평로 47길 28 kt수서빌딩 1층 ktMOS북부 사업계획팀
                            <br />
                            ㅇ 제출기간: 2022.09.19(월) 09:00~2022.09.21(수) 18:00
                            <br />
                            ㅇ 우선협상대상자 선정 : 해당업체 별도 통보
                            <br />
                            <br />
                            3. 입찰참가자격
                            <br />
                            <br />
                            ㅇ 본 입찰은 당사가 별도로 지명통보한 업체간 지명경쟁입찰입니다.
                            <br />
                            <br />
                            4. 입찰 시 제출서류 및 세부내용 첨부파일 참조
                            <br />
                            <br />
                            문의처: ktMOS북부 기술총괄 사업계획팀 남광필 010-2917-8093 (문의시간 10:00 ~ 17:00)​
                        </p> */}
                        {/* <p dangerouslySetInnerHTML={{ __html: data.contents }}></p> */}
                        <Viewer initialValue={data.contents || ""} />;
                    </div>
                    <div className="board-detail-next">
                        {data.prev ? (
                            <Link to={`/promotion/board/info/${data.prev.board}/${data.prev.id}`} className="prev">
                                <span className="cate">이전글</span>
                                <span className="sbj">{data.prev.title}</span>
                            </Link>
                        ) : (
                            <a href="#" className="prev">
                                <span className="cate"></span>
                                <span className="sbj"></span>
                            </a>
                        )}
                        {data.next ? (
                            <Link to={`/promotion/board/info/${data.next.board}/${data.next.id}`} className="next">
                                <span className="cate">다음글</span>
                                <span className="sbj">{data.next.title}</span>
                            </Link>
                        ) : (
                            <a href="#" className="next">
                                <span className="cate"></span>
                                <span className="sbj"></span>
                            </a>
                        )}
                    </div>
                    <div className="board-detail-btns">
                        <button
                            type="button"
                            className="btn_nor lg red-line"
                            onClick={() => {
                                navigate("/promotion/board/list", { replace: true });
                            }}
                        >
                            목록
                        </button>
                    </div>
                </div>
            </main>
        </>
    );
};

export default Info;
